import { Theme } from "@mui/material";
import { SystemStyleObject } from "@mui/system";
import { inAnimation } from "../../animations/animations";

export const classes: Record<string, SystemStyleObject<Theme>> = {
  root: {
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    animation: `${inAnimation} .5s cubic-bezier(.9,.1,.1,.9)`,
  },

  message: {
    color: "text.secondary",
  },

  icon: {
    fontSize: 40,
  },
};
